export const values = {
  'forgot_password': 'Elfelejtett jelszó',

  /** Common */
  'price_list': 'Árlista',
  'language': 'Nyelv',
  'details': 'Részletek',
  'add': 'Hozzáadás',
  'save': 'Mentés',

  // Orderer
  'orderer_info': 'Megrendelő adatai',
  'project_name': 'Projekt név',
  'phone': 'Telefonszám',
  'email': 'E-mail cím',
  'country': 'Ország',
  'zip': 'Irányítószám',
  'city': 'Település',
  'address': 'Cím',

  // Dimensions
  'cover_dimensions': 'Medencefedés méretei',
  'cover_type': 'Medencefedés típusa',
  'length': 'Hosszúság',
  'inner_width': 'Sínbelső',
  'outer_width': 'Sínkülső',
  'add_segment': 'Szegmens hozzáadása',
  'segment_count': 'Szegmens szám',
  'segment_length': 'Szegmens hossz',
  'height': 'Magasság',
  'rail_width': 'Sínszélesség',
  'rubber_height': 'Aljagumi magassága',
  'rear_rubber_height': 'Aljagumi magassága a hátfalon',
  'walkable_side': 'Járható oldal',
  'rail_side': 'Sínes oldal',
  'no_rail': 'Sín nélküli kivitel',
  'left_side': 'Bal oldal',
  'right_side': 'Jobb oldal',
  'left': 'Bal',
  'right': 'Jobb',

  // Doors
  'doors': 'Ajtók',
  'side_doors': 'Oldalajtók',
  'door_placement': 'Ajtó elhelyezése',
  'sliding_and_opening_doors': 'Toló és nyíló ajtók',
  'door_type': 'Ajtó típusa',
  'door_size': 'Ajtó mérete',
  'door_position': 'Ajtó pozíciója',
  'in_center': 'Középen',
  'from_left': 'Balról',
  'from_right': 'Jobbról',
  'open_direction': 'Nyitásirány',
  'variation': 'Opció',
  'with_sill': 'Küszöbbel',
  'without_sill': 'Küszöb nélkül',
  'with-sill': 'Küszöbbel',
  'without-sill': 'Küszöb nélkül',
  'right-to-left': 'Jobbról balra',
  'left-to-right': 'Balról jobbra',
  'folding_doors': 'Felnyitható ajtók',
  'framed': 'Keretes',
  'frameless': 'Keret nélküli',
  'other_doors': 'Egyéb ajtók',

  // Options
  'options': 'Opciók',
  'painting': 'Porfestés',
  'glazing': 'Üvegezés',
  'increase_height': 'Magasságnövelés',
  'rail_extension': 'Sínhosszabbítás',
  'other_technical_info': 'Egyéb technikai információk',

  // Pricing
  'pricing_options': 'Árazási opciók',
  'custom_shipping_price': 'Egyedi szállítási ár',
  'custom_install_price': 'Egyedi telepítési ár',
  'discount': 'Kedvezmény',

  // Blueprint
  'blueprint': 'Tervrajz',

  // PDF
  'item_name': 'Tétel megnevezése',
  'net_amount': 'Nettó érték',
  'vat': 'ÁFA',
  'vat_amount': 'ÁFA érték',
  'gross_amount': 'Bruttó érték',
  'in_base_price': 'Alapárban',
  'total': 'Végösszeg',
  'discounted_price': 'Kedvezményes összeg',
  'shipping_price': 'Szállítási költség',
  'install_price': 'Telepítési költség',
  'final_total': 'Összesen',

  'type_cover': 'medencefedés',
  'outer_dimensions': 'Külső méretek',

  'actions': 'Műveletek',
  'date': 'Dátum',
  'identifier': 'Azonosító',
  'type': 'Típus',
  'price': 'Ár',
  'download': 'Letöltés',
  'only_download_bid': 'Csak az árajánlat letöltése',
  'only_download_order': 'Csak a rendelés letöltése',
  'only_download_blueprint': 'Csak a tervrajz letöltése',
  'edit': 'Módosítás',
  'version_history': 'Változás történet',
  'show_revision_history': 'Változás történet megtekintése',

  'base_price': 'Alapár',
  'logout': 'Kijelentkezés',
  'create': 'Létrehozás',
  'status': 'Státusz',

  'other_data': 'Egyéb információk',
  'installable_from': 'Telepíthető az alábbi időponttól',
  'pavement': 'Medence körüli burkolat',

  'partners': 'Partnerek',
  'new_partner': 'Új partner',
  'partner_list': 'Partnerek listája',
  'events': 'Események',
  'manage_employees': 'Alkalmazottak kezelése',
  'add_payment': 'Befizetés hozzáadása',
  'add_expense': 'Költség hozzáadása',
  'add_nivobidid': 'Nivobid azonosító hozzáadása',
  'add_production_date': 'Gyártási dátum hozzáadása',
  'change_status': 'Státusz módosítása',

  'debt': 'Tartozás',
  'amount': 'Összeg',
  'send': 'Küldés',
  'request_modification': 'Módosítási kérelem',
  'request_from': 'Módosítási idő kezdete',
  'request_to': 'Módosítási idő vége',

  'name': 'Név',
  'available_pricelists': 'Elérhető árlisták',
  'available_languages': 'Elérhető nyelvek',
  'password': 'Jelszó',
  'permissions': 'Jogosultságok',

  'customer_bids': 'Vevői árajánlatok',
  'company_customer_bids': 'Céges vevői árajánlatok',
  'supplier_bids': 'Szállítói árajánlatok',
  'company_supplier_bids': 'Céges szállítói árajánlatok',
  'customer_orders': 'Vevői rendelések',
  'company_customer_orders': 'Céges vevői rendelések',
  'supplier_orders': 'Szállítói rendelések',
  'company_supplier_orders': 'Céges szállítói rendelések',
  'employees': 'Alkalmazottak',
  'order_status': 'Rendelési státusz',
  'order_payments': 'Rendelés befizetések',
  'order_expenses': 'Rendelés költségek',
  'nivobidid': 'Nivobid azonosító',
  'production_date': 'Gyártási dátum',
  'save_partner': 'Partner mentése',
  'delete': 'Törlés',
  'company_info': 'Cégadatok',
  'app_configuration': 'Alkalmazás konfigurálása',
  'primary_user': 'Elsődleges felhasználó',
  'view': 'Megtekintés',
  'user_info': 'Felhasználó adatai',
  'new': 'Új',
  'tos': 'A rendelés leadásával elfogadja ÁSZF-ünket',
  'added_doors': 'Hozzárendelt ajtók',
  'no_doors_added': 'Nincs ajtó hozzárendelve',
  'user': 'Felhasználó',
  'data': 'Adat',
  'old_value': 'Régi érték',
  'new_value': 'Új érték',
  'weight': 'Súly',
  'filter': 'Szűrő',
  'powder_coating': 'Porfestés',
  'door': 'Ajtó',
  'deleted': 'Törölve',
  'shipping_address': 'Szállítási cím',
  'note': 'Megjegyzés',
  'apply_special_solutions': 'Speciális szerkezeti megoldások engedélyezése',
  'wall_side': 'Fal oldal',
  'apply_custom_vat': 'Egyedi ÁFA hozzáadása',
  'pricelist': 'Árlista',
  'datasheet': 'Adatlap',
  'terms_of_services': 'Á.SZ.F.',
  'user_manual': 'Használati utasítás',
  'manage_invoices': 'Számlák kezelése',
  'transports': 'Szállítások',
  'lock_side': 'Zárható oldal',

  /** Vouchers */
  'bids': 'Árajánlatok',
  'create_customer_bid': 'Vevői árajánlat létrehozása',
  'create_supplier_bid': 'Szállítói árajánlat létrehozása',
  'customer_bids_list': 'Vevői árajánlatok listája',
  'supplier_bids_list': 'Szállítói árajánlatok listája',
  'save_bid': 'Árajánlat mentése',
  'save_bid_as_new': 'Árajánlat mentése újként',
  'edit_bid': 'Árajánlat módosítása',
  'delete_bid': 'Árajánlat törlése',

  'orders': 'Rendelések',
  'create_customer_order': 'Vevői rendelés létrehozása',
  'create_supplier_order': 'Szállítói rendelés létrehozása',
  'customer_orders_list': 'Vevői rendelések listája',
  'supplier_orders_list': 'Szállítói rendelések listája',
  'orders_list': 'Rendelések listája',
  'save_order': 'Rendelés mentése',
  'edit_order': 'Rendelés módosítása',
  'delete_order': 'Rendelés törlése',

  'bid': 'Árajánlat',
  'order': 'Rendelés',
  'bid_issuer': 'Ajánlatadó',
  'supplier': 'Szállító',
  'bid_recipient': 'Ajánlatkérő',
  'orderer': 'Megrendelő',


  'front_wall': 'Homlokfal',
  'rear_wall': 'Hátfal',
  'segment_a': 'Legnagyobb szegmens bal első "A"',
  'segment_b': 'Legnagyobb szegmens bal hátsó "B"',
  'segment_c': 'Legnagyobb szegmens jobb első "C"',
  'segment_d': 'Legnagyobb szegmens jobb hátsó "D"',
  'side': 'Oldalfal',

  'elo_hatfal_4mm_tomor': 'Elő- és hátfal 4 mm-es tömör víztiszta polikarbonáttal',
  'oldalfal_tomor': 'Oldalfal tömör polikarbonát',
  'homlok_vegfal_4mm_biztonsagi': 'A homlok- és végfal 4 mm-es biztonsági üveg',
  'egyenes_oldal_4mm_biztonsagi': 'Az egyenes hosszú oldal 4 mm-es biztonsági üveg',
  '10mm_natur_legkamras': '10 mm-es natúr légkamrás polikarbonát',
  '10mm_egkek_legkamras': '10 mm-es légkamrás égkék polikarbonát',
  '6mm_natur_legkamras': '6 mm-es natúr légkamrás polikarbonát',
  'homlok_4mm_biztonsagi': 'A homlokfal 4 mm-es biztonsági üveg',
  'vegfal_4mm_biztonsagi': 'A végfal 4 mm-es biztonsági üveg',
  'oldalfal_4mm_biztonsagi': 'Oldalfalak 4 mm-es biztonsági üvegezéssel',
  'homlok_4mm_tomor': 'A homlokfal 4 mm-es tömör víztiszta polikarbonáttal',
  'vegfal_4mm_tomor': 'A végfal 4 mm-es tömör víztiszta polikarbonáttal',
  'homlok_3mm_tomor': 'A homlokfal 3 mm-es tömör víztiszta polikarbonáttal',
  'vegfal_3mm_tomor': 'A végfal 3 mm-es tömör víztiszta polikarbonáttal',
  'homlok_vegfal_3mm_tomor': 'Elő- és hátfal 3 mm-es tömör víztiszta polikarbonáttal',
  'teljes_3mm_tomor': 'Teljes 3 mm-es víztiszta polikarbonát üvegezés',
  'teljes_4mm_tomor_egkek': 'Teljes 4 mm-es égkék tömör üvegezés',
  'teljes_4mm_tomor': 'Teljes 4 mm-es víztiszta polikarbonát üvegezés',


  'keret_nelkuli_felnyilo': 'Keret nélküli felnyíló ajtó',
  'keretes_felnyilo_ajto': 'Keretes felnyíló ajtó',
  'toloajto': 'Tolóajtó',
  'felnyilo_gumi': '90° / 180°-ig felnyitható 12 / 15 / 17 cm magas gumi',
  'romai_lepcso': 'Római lépcső lefedés (Ø 1.5m)',
  'szellozo_ablak': 'Szellőző ablak',
  'homlokfali_dupli_toloajto': 'Homlokfali dupla tolóajtó',
  'nyiloajto_kuszobbel': 'Nyílóajtó',
  'kuszob_nelkuli_nyiloajto': 'Küszöb nélküli nyílóajtó',
  'side_door': 'Eltolható oldalajtó',
  'kuszob_nelkuli_toloajto': 'Küszöb nélküli tolóajtó',
  'sidedoor_c': 'Oldalajtó jobb első "C"',
  'sidedoor_a': 'Oldalajtó bal első "A"',
  'sidedoor_b': 'Oldalajtó bal hátsó "B"',
  'sidedoor_d': 'Oldalajtó jobb hátsó "D"',


  'magasitott_szegmens': 'Második magasított szegmens',
  'standard_xtr': 'Standard méretű fedés XTR profilból történő gyártása',
  'homlokfal_nelkul': 'Homlokfal nélküli kivitel',
  'vegfal_nelkul': 'Végfal nélküli kivitel',
  'ajtok_zarhatok': 'Csak az ajtó(k) zárható(k)',
  'osszes_zarhato': 'Összes elem zárható',
  'csomagolas': 'Minden szegmens külön becsomagolása védőfóliába és szivacsprofilba',
  'extra_szegmens': 'Egyedi szegmens felosztás',
  'extra_magassag': 'Magasságnövelés',
  'fix_homlokfal': 'Önálló fix (nem eltolható) homlokfal',

  'from': '-tól',
  'to': '-ig',


  'pending': 'Függőben',
  'waiting_for_deposit': 'Előlegre vár',
  'closed': 'Lezárt',
  'waiting_for_modification': 'Módosításra vár',
  'waiting_for_approval': 'Jóváhagyásra vár',
  'in_production': 'Gyártás alatt',
  'waiting_for_shipping': 'Szállításra vár',
  'shipped': 'Szállítva',
  'completed': 'Teljesített',
  'parking': 'Parkoló'

};



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/locales/hu.ts